module.exports = __webpack_public_path__ + "static/img/20231128_02.a0813a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231128_02.png
// module id = 5Qq0
// module chunks = 0